import config from 'config';

import { tabsAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(tabsAnatomy.keys);

const {
  colors: {
    palette: {
      theme: { tabs: styles }
    }
  }
} = config;

const baseStyle = definePartsStyle({
  root: {
    backgroundColor: styles.tabsRootBg
  }
});

const Tabs = defineMultiStyleConfig({ baseStyle });

export default Tabs;
